import { SafeBaseObject } from "@app/core/models/base-object.models";

export interface IRescomApiInvokeAIParams {
    Context: string;
    Field: string;
    Mode: 'interactive' | 'batch';
    Text: string;
    User?: string;
}

export class RescomApiInvokeAI extends SafeBaseObject {
    result?: RescomApiInvokeAIResult
    sessionID = 0

    constructor(data: any) {
        super();
        if (data) this.updateData(data);
        if (data.result) this.result = new RescomApiInvokeAIResult(data.result);
    }
}

export class RescomApiInvokeAIResult extends SafeBaseObject {
    description = ''
    title = ''

    constructor(data: any) {
        super();
        if (data) this.updateData(data);
    }

}


